module.exports = __webpack_public_path__ + "assets/static/png/visa_verified.946fca6d55cd8dfb293bae4cee48efc6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/footer/images/visa_verified.png
 ** module id = 480
 ** module chunks = 1
 **/